import {
    QUOTA_TYPE_CANDIDATE_QUOTA_ID,
    QUOTA_TYPE_RESERVED_SEATS_ID
} from '../../../constants';
import { CountryProfile, Taxonomies } from '../../../types';
import { getTaxonomyName } from "../../../utils";

interface ValuesForChart {
    withReservedSeats: {
        count: number,
        tooltip: string[],
    },
    withCandidateQuota: {
        count: number,
        tooltip: string[],
    },
    both: {
        count: number,
        tooltip: string[],
    },
}

export const getValuesForChart = (
    countryProfiles: CountryProfile[],
    taxonomies: Taxonomies
) => {
    const result: ValuesForChart = {
        withReservedSeats: {
            count: 0,
            tooltip: [],
        },
        withCandidateQuota: {
            count: 0,
            tooltip: [],
        },
        both: {
            count: 0,
            tooltip: [],
        },
    };

    // const countryProfilesWithReservedSeats: CountryProfile[] = [];
    // const countryProfilesWithCandidateQuota: CountryProfile[] = [];
    // const countryProfilesWithBoth: CountryProfile[] = [];

    countryProfiles.forEach(countryProfile => {
        let both: boolean = (
            countryProfile.typeOfQuotaIds.includes(QUOTA_TYPE_CANDIDATE_QUOTA_ID)
            && countryProfile.typeOfQuotaIds.includes(QUOTA_TYPE_RESERVED_SEATS_ID)
        );

        const countryName = getTaxonomyName(taxonomies, 'countries', countryProfile.countryId);

        if (both) {
            result.both.count++;
            result.both.tooltip.push(countryName);
            result.withCandidateQuota.tooltip.push(countryName);
            result.withReservedSeats.tooltip.push(countryName);
        }
        else {
            countryProfile.typeOfQuotaIds.forEach(typeOfQuotaId => {
                switch (typeOfQuotaId) {
                    case QUOTA_TYPE_CANDIDATE_QUOTA_ID:
                        if (!both) {
                            result.withCandidateQuota.count++;
                        }
                        result.withCandidateQuota.tooltip.push(countryName);
                        break;

                    case QUOTA_TYPE_RESERVED_SEATS_ID: 
                        if (!both) {
                            result.withReservedSeats.count++;
                        }
                        result.withReservedSeats.tooltip.push(countryName);
                        break;
                }
            });
        }
    });

    // const countryProfilesWithReservedSeatsCountryNames: string[] = countryProfilesWithReservedSeats
    //     .map(profile => getTaxonomyName(taxonomies, 'countries', profile.countryId));

    // const countryProfilesWithCandidateQuotaCountryNames: string[] = countryProfilesWithCandidateQuota
    //     .map(profile => getTaxonomyName(taxonomies, 'countries', profile.countryId));

    // const countryProfilesWithBothCountryNames: string[] = countryProfilesWithBoth
    //     .map(profile => getTaxonomyName(taxonomies, 'countries', profile.countryId));

    result.withReservedSeats.tooltip.sort((a, b) => a > b ? 1 : -1);
    result.withCandidateQuota.tooltip.sort((a, b) => a > b ? 1 : -1);
    result.both.tooltip.sort((a, b) => a > b ? 1 : -1);

    return result;
};
